import { useRef } from 'react';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import UserMenu from '../../components/UserMenu';

import * as S from './styles';
import { Grid } from '@material-ui/core';

const PlayerLayout = ({ children }: any) => {
  const mediaRef = useRef<any>();
  const mediaQueryMatches = useMediaQuery('(max-width: 730px)');

  return (
    <S.StyledContainer maxWidth={false}>
      <S.StyledGrid
        container
        direction={mediaQueryMatches ? 'column' : 'row'}
        style={{
          flexWrap: mediaQueryMatches ? 'nowrap' : 'wrap',
        }}
      >
        <S.StyledGrid
          item
          lg={2}
          md={2}
          sm={12}
          xs={12}
          style={{ width: '100%' }}
        >
          <S.StyledCard>
           {children[0]}
          </S.StyledCard>
        </S.StyledGrid>
        <S.StyledGrid
          item
          lg={10}
          md={10}
          sm={12} 
          xs={12}
          style={S.iframeGridStyle}
          ref={mediaRef}
        >
          {children[1]}
          <UserMenu />

        </S.StyledGrid>
        
      </S.StyledGrid>
    </S.StyledContainer>
  );
};


export default PlayerLayout;
